const initialState = {
    catalog: [],
    predefinedTemplates: [],
    loadingCatalog: false,
    loadingTemplates: false,
    catalogError: null,
    templatesError: null,
    upgradeDrawer: {
        open: false,
        featureName: '',
        requiredPlan: ''
    }
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_APP_CATALOG_START':
            return { ...state, loadingCatalog: true, catalogError: null };

        case 'FETCH_APP_CATALOG_SUCCESS':
            return {
                ...state,
                catalog: action.payload,
                loadingCatalog: false,
                catalogError: null
            };

        case 'FETCH_APP_CATALOG_FAILURE':
            return {
                ...state,
                loadingCatalog: false,
                catalogError: action.payload
            };

        case 'FETCH_PREDEFINED_TEMPLATES_START':
            return { ...state, loadingTemplates: true, templatesError: null };

        case 'FETCH_PREDEFINED_TEMPLATES_SUCCESS':
            return {
                ...state,
                predefinedTemplates: action.payload,
                loadingTemplates: false,
                templatesError: null
            };

        case 'FETCH_PREDEFINED_TEMPLATES_FAILURE':
            return {
                ...state,
                loadingTemplates: false,
                templatesError: action.payload
            };

        case 'OPEN_UPGRADE_DRAWER':
            return { ...state, upgradeDrawer: { open: true, featureName: action.payload?.featureName || '', requiredPlan: action.payload?.requiredPlan || '' } };

        case 'CLOSE_UPGRADE_DRAWER':
            return { ...state, upgradeDrawer: { open: false, featureName: '', requiredPlan: '' } };

        case 'LOGOUT_START':
            return initialState;

        default:
            return state;
    }
};

export default appReducer;
